if(document.body.classList.contains("template-product")){
document.addEventListener("DOMContentLoaded",()=>{

    document.querySelectorAll(".product-accordion").forEach(accordion=>{

        const header=accordion.querySelector(".product-accordion__header");
        const body=accordion.querySelector(".product-accordion__body");

        const content=accordion.querySelector(".product-description-content");
        const button=accordion.querySelector(".product-description-toggle");

        accordion.classList.remove("closed");

        if(content.scrollHeight<=content.clientHeight+5){
            button.style.display="none";
        }

        button.addEventListener("click",()=>{

            content.classList.toggle("is-open");

            button.innerHTML=content.classList.contains("is-open")
                ?"Read less"
                :"Read more";

        });

        header.addEventListener("click",()=>{

            accordion.classList.toggle("closed");

        });

    });

});
}
